import React from "react";

// react-router components
import { Navigate, Routes, Route } from "react-router";

// LCM partner routes - user role = partner required
import routes from "partner.routes";
import Partner from "./Partner";

const PartnerRoutes = () => {
  // const isAuthenticated = useSelector((state) => state.users.isAuthenticated);
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }
      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={<Partner>{route.component}</Partner>}
            key={route.key}
          />
        );
      }

      return null;
    });

  return (
    <Routes>
      {getRoutes(routes)}
      <Route path="*" element={<Navigate to="/partner/dashboards" />} />
    </Routes>
  );
};

export default PartnerRoutes;
